import * as loginTypes from './loginTypes';
import { goBack } from 'connected-react-router';
import { userRolesConfig } from 'src/helpers';
import { LOGINPAGE } from './constants';

export const requestloginInformation = () => ({
  type: loginTypes.GET_LOGIN_INFORMATION,
});

export const requestloginInformationSuccess = data => ({
  type: loginTypes.GET_LOGIN_INFORMATION_SUCCESS,
  data,
});

export const requestloginInformationFailure = error => ({
  type: loginTypes.GET_LOGIN_INFORMATION_FAILURE,
  error,
});

export const login = (username, password) => ({
  type: loginTypes.POST_LOGIN_PENDING,
  username,
  password,
});

export const loginSso = () => ({
  type: loginTypes.POST_LOGIN_SSO_PENDING,
});

export const loginSuccess = data => dispatch => {
  dispatch({
    type: loginTypes.POST_LOGIN_SUCCESS,
    data,
  });
};

export const loginSsoSuccess = data => dispatch => {
  dispatch({
    type: loginTypes.POST_LOGIN_SUCCESS,
    data,
  });
};

export const loginFailure = error => ({
  type: loginTypes.POST_LOGIN_FAILURE,
  error,
});

export const loginSsoFailure = error => ({
  type: loginTypes.POST_LOGIN_FAILURE,
  error,
});

export const clearErrors = () => ({
  type: loginTypes.CLEAR_ERRORS,
});

export const gotoPage = page => {
  switch (page) {
    case LOGINPAGE:
      return { type: loginTypes.GOTO_LOGIN };
    default:
      return { type: loginTypes.GOTO_LOGIN_SSO };
  }
};

export const returnToLogin = () => goBack();

export const userValidateToken = () => ({
  type: loginTypes.USER_VALIDATE_TOKEN,
});

export const userValidateSuccess = data => ({
  type: loginTypes.USER_VALIDATE_SUCCESS,
  data,
});

export const validateUserPending = () => {
  return {
    type: loginTypes.VALIDATE_USER_PENDING,
  };
};

export const validateUserSuccess = data => ({
  type: loginTypes.VALIDATE_USER_SUCCESS,
  data,
});

export const validateUserFailure = error => ({
  type: loginTypes.VALIDATE_USER_FAILURE,
  error,
});

export const updateUserRoles = data => {
  const userRoles = userRolesConfig(data);

  return {
    type: loginTypes.UPDATE_USER_ROLES,
    userRoles,
  };
};

export const clearSession = () => ({
  type: loginTypes.CLEAR_SESSION,
});

export const logoutSession = () => ({
  type: loginTypes.LOGOUT_SESSION,
});

export const setUserInfoFromStorage = userData => ({
  type: loginTypes.SET_USER_FROM_SESSION,
  data: {
    ...userData,
    userRoles: userRolesConfig(userData),
    isValidated: true,
  },
});

export const changeRoleSelection = state => ({
  type: loginTypes.CHANGE_ROLE_SELECTION,
  state,
});
